import { defaultScaffold } from "@Light/scaffold/default";
import { PortalHeader } from "./components/PortalHeader";

export const scaffold = {
  ...defaultScaffold,
  page: {
    ...defaultScaffold.page,
    splashImage: true,
    header: {
      ...defaultScaffold.page.header,
      header: PortalHeader,
    },
  },
};
